export const MAX_DELEGATIONS = 25;
export const BASE_MIN_DELEGATION = 5000;
export const MANTA_BASE_MIN_DELEGATION = 500;
export const POINTS_PER_BLOCK = 20;
export const SECONDS_PER_BLOCK = 12;
